(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-instagram-video-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSection(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const productAutoplayMs = Number(root.dataset.productAutoplayMs || 5000);
      const videoModal = root.querySelector('[data-video-modal]');
      const videoModalContent = root.querySelector('[data-video-modal-content]');
      const videoClose = root.querySelector('[data-video-close]');

      const variantModal = root.querySelector('[data-variant-modal]');
      const variantClose = root.querySelector('[data-variant-close]');
      const variantSelect = root.querySelector('[data-variant-select]');
      const variantPicker = root.querySelector('[data-variant-picker]');
      const variantTrigger = root.querySelector('[data-variant-trigger]');
      const variantTriggerText = root.querySelector('[data-variant-trigger-text]');
      const variantOptions = root.querySelector('[data-variant-options]');
      const variantConfirm = root.querySelector('[data-variant-confirm]');
      const variantProductTitle = root.querySelector('[data-variant-product-title]');
      const variantError = root.querySelector('[data-variant-error]');
      const successNotice = root.querySelector('[data-add-success]');

      let selectedVariant = null;
      const productAutoTimers = [];
      const SCROLL_LOCK_COUNT_KEY = '__sigalleryScrollLockCount';
      const PREV_HTML_OVERFLOW_KEY = '__sigalleryPrevHtmlOverflow';
      const PREV_BODY_OVERFLOW_KEY = '__sigalleryPrevBodyOverflow';

      function lockPageScroll() {
        const html = document.documentElement;
        const body = document.body;
        if (!html || !body) return;

        const currentCount = Number(window[SCROLL_LOCK_COUNT_KEY] || 0);
        if (currentCount === 0) {
          window[PREV_HTML_OVERFLOW_KEY] = html.style.overflow;
          window[PREV_BODY_OVERFLOW_KEY] = body.style.overflow;
          html.style.overflow = 'hidden';
          body.style.overflow = 'hidden';
        }

        window[SCROLL_LOCK_COUNT_KEY] = currentCount + 1;
      }

      function unlockPageScroll() {
        const html = document.documentElement;
        const body = document.body;
        if (!html || !body) return;

        const currentCount = Number(window[SCROLL_LOCK_COUNT_KEY] || 0);
        if (currentCount <= 1) {
          html.style.overflow = typeof window[PREV_HTML_OVERFLOW_KEY] === 'string' ? window[PREV_HTML_OVERFLOW_KEY] : '';
          body.style.overflow = typeof window[PREV_BODY_OVERFLOW_KEY] === 'string' ? window[PREV_BODY_OVERFLOW_KEY] : '';
          window[SCROLL_LOCK_COUNT_KEY] = 0;
          delete window[PREV_HTML_OVERFLOW_KEY];
          delete window[PREV_BODY_OVERFLOW_KEY];
          return;
        }

        window[SCROLL_LOCK_COUNT_KEY] = currentCount - 1;
      }

      function clearTimer(timer) {
        if (timer) window.clearInterval(timer);
      }

      function clearProductTimers() {
        productAutoTimers.forEach((timer) => clearTimer(timer));
        productAutoTimers.length = 0;
      }

      function updateDots(dotWrap, total, active, onClick) {
        if (!dotWrap || total <= 1) {
          if (dotWrap) dotWrap.innerHTML = '';
          return;
        }
        dotWrap.innerHTML = '';
        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `sigallery__dot${i === active ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => onClick(i));
          dotWrap.appendChild(dot);
        }
      }

      function showSuccess(message) {
        if (!successNotice) return;
        successNotice.textContent = message || 'Added to cart';
        successNotice.hidden = false;
        window.setTimeout(() => {
          successNotice.hidden = true;
        }, 2200);
      }

      function getCartAddUrl() {
        return (window.routes && window.routes.cart_add_url)
          || (window.Shopify && window.Shopify.routes && (window.Shopify.routes.root || '') + 'cart/add.js')
          || '/cart/add.js';
      }

      function getCartUrl() {
        return (window.routes && window.routes.cart_url) || '/cart';
      }

      async function refreshCartCount() {
        try {
          const response = await fetch(getCartUrl() + '?view=compare', {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
            window.wetheme.updateCartCount(cart);
          }
        } catch (_error) {
          /* silent */
        }
      }

      function openCartDrawer() {
        if (window.eventBus && typeof window.eventBus.emit === 'function') {
          window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
          return true;
        }
        return false;
      }

      function renderCartDrawer(responseJson) {
        if (!window.eventBus || typeof window.eventBus.emit !== 'function') return;
        if (responseJson && responseJson.sections && responseJson.sections['cart-drawer']) {
          window.eventBus.emit('update:cart:drawer', responseJson);
        } else {
          window.eventBus.emit('render:cart:drawer');
        }
      }

      async function addToCart(variantId, button) {
        if (!variantId) return;
        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
        }
        if (variantError) {
          variantError.hidden = true;
          variantError.textContent = '';
        }

        try {
          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          formData.append('sections', 'cart-drawer');
          formData.append('sections_url', window.location.pathname);

          const response = await fetch(getCartAddUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const data = await response.json();

          if (!response.ok || data.status === 422 || data.status === '422') {
            throw new Error(data?.description || data?.message || 'Unable to add this product.');
          }

          renderCartDrawer(data);
          await refreshCartCount();

          if (variantModal?.open) variantModal.close();
          if (videoModal?.open) videoModal.close();

          const opened = openCartDrawer();
          if (!opened) {
            showSuccess('Product added to cart');
          }
        } catch (error) {
          if (variantError) {
            variantError.hidden = false;
            variantError.textContent = error.message || 'Unable to add this product.';
          } else {
            showSuccess(error.message || 'Unable to add this product.');
          }
        } finally {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          }
        }
      }

      function closeVariantDropdown() {
        if (!variantPicker || !variantTrigger || !variantOptions) return;
        variantPicker.classList.remove('is-open');
        variantTrigger.setAttribute('aria-expanded', 'false');
        variantOptions.hidden = true;
      }

      function openVariantDropdown() {
        if (!variantPicker || !variantTrigger || !variantOptions) return;
        variantPicker.classList.add('is-open');
        variantTrigger.setAttribute('aria-expanded', 'true');
        variantOptions.hidden = false;
      }

      function setSelectedVariant(variantId) {
        selectedVariant = String(variantId || '');
        if (variantSelect) variantSelect.value = selectedVariant;

        if (variantTriggerText && variantSelect) {
          const selectedOption = variantSelect.querySelector(`option[value="${selectedVariant}"]`);
          variantTriggerText.textContent = selectedOption ? selectedOption.textContent : 'Choose variant';
        }

        if (variantOptions) {
          variantOptions.querySelectorAll('[data-variant-option-id]').forEach((optionBtn) => {
            const isSelected = optionBtn.dataset.variantOptionId === selectedVariant;
            optionBtn.classList.toggle('is-selected', isSelected);
            optionBtn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
        }
      }

      function renderVariantOptions(variants) {
        if (!variantOptions) return;
        variantOptions.innerHTML = '';
        variants.forEach((variant) => {
          const item = document.createElement('li');
          item.setAttribute('role', 'presentation');

          const optionButton = document.createElement('button');
          optionButton.type = 'button';
          optionButton.className = 'sigallery__variant-option';
          optionButton.setAttribute('role', 'option');
          optionButton.setAttribute('aria-selected', 'false');
          optionButton.setAttribute('data-variant-option-id', String(variant.id));
          optionButton.textContent = variant.title;

          item.appendChild(optionButton);
          variantOptions.appendChild(item);
        });
      }

      function openVariantModal(productData) {
        if (!variantModal || !variantSelect) return;
        const variants = (productData?.variants || []).filter((variant) => variant.available);
        variantSelect.innerHTML = '';
        selectedVariant = null;

        variants.forEach((variant, index) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title;
          variantSelect.appendChild(option);
          if (index === 0) selectedVariant = String(variant.id);
        });
        renderVariantOptions(variants);
        setSelectedVariant(selectedVariant);
        closeVariantDropdown();

        if (variantProductTitle) {
          variantProductTitle.textContent = productData?.title || '';
        }
        if (variantError) {
          variantError.hidden = true;
          variantError.textContent = '';
        }
        if (typeof variantModal.showModal === 'function') variantModal.showModal();
      }

      function setupProductCards() {
        root.addEventListener('click', (event) => {
          const addBtn = event.target.closest('[data-add-product]');
          if (!addBtn || !root.contains(addBtn)) return;
          if (addBtn.disabled || addBtn.classList.contains('sigallery__add--disabled')) return;

          const card = addBtn.closest('[data-product-card]');
          if (!card || !root.contains(card)) return;

          const productJsonEl = card.querySelector('[data-product-json]');
          if (!productJsonEl) return;

          let productData = null;
          try {
            productData = JSON.parse(productJsonEl.textContent);
          } catch (_error) {
            productData = null;
          }
          if (!productData) return;

          const availableVariants = (productData.variants || []).filter((variant) => variant.available);
          if (!availableVariants.length) return;
          if (availableVariants.length === 1) {
            addToCart(availableVariants[0].id, addBtn);
            return;
          }
          openVariantModal(productData);
        });
      }

      function setFallbackProductSlide(state, index) {
        state.items.forEach((item, itemIndex) => {
          item.style.display = itemIndex === index ? 'flex' : 'none';
        });
      }

      function startFallbackAutoScroll(state) {
        if (!state || state.total <= 1) return;
        const timer = window.setInterval(() => {
          state.index = (state.index + 1) % state.total;
          setFallbackProductSlide(state, state.index);
          updateDots(state.pagination, state.total, state.index, (dotIndex) => {
            state.index = dotIndex;
            setFallbackProductSlide(state, dotIndex);
          });
        }, productAutoplayMs);
        productAutoTimers.push(timer);
      }

      function initProductSliders() {
        root.querySelectorAll('[data-product-list]').forEach((list) => {
          const count = Number(list.dataset.productCount || 0);
          const pagination = list.parentElement.querySelector('[data-product-pagination]');
          const navWrap = list.parentElement.querySelector('[data-product-nav]');
          const prevBtn = list.parentElement.querySelector('[data-product-prev]');
          const nextBtn = list.parentElement.querySelector('[data-product-next]');
          const useSlick = window.jQuery && typeof window.jQuery.fn.slick === 'function';
          const $list = useSlick ? window.jQuery(list) : null;

          list.removeAttribute('style');
          Array.from(list.children).forEach((child) => child.removeAttribute('style'));

          if (count <= 1) {
            if ($list && $list.hasClass('slick-initialized')) {
              $list.slick('unslick');
            }
            if (pagination) pagination.innerHTML = '';
            if (navWrap) navWrap.hidden = true;
            return;
          }

          if (navWrap) navWrap.hidden = false;

          if (useSlick) {
            if (!$list.hasClass('slick-initialized')) {
              $list.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !!(prevBtn && nextBtn),
                prevArrow: prevBtn ? window.jQuery(prevBtn) : undefined,
                nextArrow: nextBtn ? window.jQuery(nextBtn) : undefined,
                dots: true,
                autoplay: false,
                adaptiveHeight: true,
                appendDots: pagination ? window.jQuery(pagination) : window.jQuery(list)
              });
            }
            return;
          }

          list.style.display = 'block';
          list.style.overflow = 'hidden';

          const state = {
            index: 0,
            total: count,
            items: Array.from(list.children),
            pagination
          };
          setFallbackProductSlide(state, 0);
          updateDots(pagination, count, 0, (dotIndex) => {
            state.index = dotIndex;
            setFallbackProductSlide(state, dotIndex);
          });
          if (prevBtn) {
            prevBtn.onclick = () => {
              state.index = (state.index - 1 + state.total) % state.total;
              setFallbackProductSlide(state, state.index);
              updateDots(pagination, state.total, state.index, (dotIndex) => {
                state.index = dotIndex;
                setFallbackProductSlide(state, dotIndex);
              });
            };
          }
          if (nextBtn) {
            nextBtn.onclick = () => {
              state.index = (state.index + 1) % state.total;
              setFallbackProductSlide(state, state.index);
              updateDots(pagination, state.total, state.index, (dotIndex) => {
                state.index = dotIndex;
                setFallbackProductSlide(state, dotIndex);
              });
            };
          }
        });
      }

      // Video carousel: CSS scroll-snap slider (reliable, shows every video in full)
      function initVideoCarousel() {
        const carousel = root.querySelector('[data-video-carousel]');
        if (!carousel) return;
        const track = carousel.querySelector('[data-video-track]');
        const prevBtn = carousel.querySelector('[data-carousel-prev]');
        const nextBtn = carousel.querySelector('[data-carousel-next]');
        const dotsWrap = carousel.querySelector('[data-carousel-dots]');
        if (!track) return;

        const slides = Array.from(track.children);
        if (!slides.length) return;

        const getStep = () => {
          const first = slides[0];
          const second = slides[1];
          if (second) {
            return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
          }
          return first.getBoundingClientRect().width;
        };

        const getVisibleCount = () => {
          const step = getStep();
          return step > 0 ? Math.max(1, Math.round(track.clientWidth / step)) : 1;
        };

        const getCurrentIndex = () => {
          const step = getStep();
          return step > 0 ? Math.round(track.scrollLeft / step) : 0;
        };

        const updateState = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          const atStart = track.scrollLeft <= 2;
          const atEnd = track.scrollLeft >= maxScroll - 2;
          if (prevBtn) prevBtn.disabled = atStart;
          if (nextBtn) nextBtn.disabled = atEnd;

          if (dotsWrap) {
            const activeIdx = getCurrentIndex();
            dotsWrap.querySelectorAll('.sigallery__carousel-dot').forEach((dot, i) => {
              dot.classList.toggle('is-active', i === activeIdx);
            });
          }
        };

        const buildDots = () => {
          if (!dotsWrap) return;
          dotsWrap.innerHTML = '';
          const visibleCount = getVisibleCount();
          const pages = Math.max(1, slides.length - visibleCount + 1);
          if (pages <= 1) {
            dotsWrap.style.display = 'none';
            return;
          }
          dotsWrap.style.display = '';
          for (let i = 0; i < pages; i += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'sigallery__carousel-dot';
            dot.setAttribute('aria-label', `Go to video ${i + 1}`);
            dot.addEventListener('click', () => {
              const step = getStep();
              track.scrollTo({ left: step * i, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
          }
        };

        prevBtn?.addEventListener('click', () => {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
        nextBtn?.addEventListener('click', () => {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        let scrollRaf = null;
        track.addEventListener(
          'scroll',
          () => {
            if (scrollRaf) cancelAnimationFrame(scrollRaf);
            scrollRaf = requestAnimationFrame(updateState);
          },
          { passive: true }
        );

        let resizeTimer = null;
        window.addEventListener('resize', () => {
          if (resizeTimer) clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            buildDots();
            updateState();
          }, 150);
        });

        buildDots();
        updateState();
      }

      function resetVideoModalAndProductSliders() {
        clearProductTimers();
        if (videoModalContent) videoModalContent.innerHTML = '';
        initProductSliders();
      }

      function pauseModalVideo() {
        const modalVideo = videoModalContent?.querySelector('.sigallery__video-modal-media');
        if (modalVideo && typeof modalVideo.pause === 'function') modalVideo.pause();
      }

      function bindVideoModal() {
        root.querySelectorAll('[data-video-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            if (!videoModal || !videoModalContent) return;
            const wrap = trigger.closest('.sigallery__video-wrap');
            const template = wrap?.querySelector('[data-video-template]');
            if (!template) return;

            const videoCard = trigger.closest('.sigallery__video-card');
            videoModalContent.innerHTML = '';

            const layout = document.createElement('div');
            layout.className = 'sigallery__video-modal-layout';

            const main = document.createElement('div');
            main.className = 'sigallery__video-modal-main';
            main.appendChild(template.content.cloneNode(true));

            const aside = document.createElement('aside');
            aside.className = 'sigallery__video-modal-side';
            aside.setAttribute('aria-label', 'Products linked to this video');

            if (videoCard) {
              const productArticles = videoCard.querySelectorAll('.sigallery__product-card');
              if (productArticles.length) {
                const productsSection = document.createElement('section');
                productsSection.className = 'sigallery__products sigallery__products--modal';

                const head = videoCard.querySelector('.sigallery__products-head');
                if (head) {
                  productsSection.appendChild(head.cloneNode(true));
                }

                const list = document.createElement('div');
                list.className = 'sigallery__products-list sigallery__products-list--modal';
                productArticles.forEach((article) => {
                  const clone = article.cloneNode(true);
                  clone.removeAttribute('style');
                  clone.querySelectorAll('[style]').forEach((node) => node.removeAttribute('style'));
                  list.appendChild(clone);
                });
                productsSection.appendChild(list);

                aside.appendChild(productsSection);
              }
            }

            if (!aside.children.length) {
              layout.classList.add('sigallery__video-modal-layout--single');
            }

            layout.appendChild(main);
            layout.appendChild(aside);
            videoModalContent.appendChild(layout);

            clearProductTimers();
            initProductSliders();

            const modalVideo = main.querySelector('video.sigallery__video-modal-media');
            if (modalVideo && typeof modalVideo.play === 'function') {
              modalVideo.play().catch(() => {});
            }

            lockPageScroll();
            try {
              if (typeof videoModal.showModal === 'function') {
                videoModal.showModal();
              } else {
                videoModal.setAttribute('open', 'open');
              }
            } catch (error) {
              unlockPageScroll();
            }
          });
        });

        if (videoClose) {
          videoClose.addEventListener('click', () => {
            if (videoModal?.open) videoModal.close();
          });
        }

        if (videoModal) {
          videoModal.addEventListener('click', (event) => {
            if (event.target === videoModal) {
              videoModal.close();
            }
          });

          videoModal.addEventListener('close', () => {
            unlockPageScroll();
            pauseModalVideo();
            resetVideoModalAndProductSliders();
          });
        }
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', (event) => {
          setSelectedVariant(event.target.value);
        });
      }
      if (variantTrigger) {
        variantTrigger.addEventListener('click', () => {
          if (!variantOptions || !variantOptions.children.length) return;
          if (variantPicker?.classList.contains('is-open')) {
            closeVariantDropdown();
          } else {
            openVariantDropdown();
          }
        });
      }
      if (variantOptions) {
        variantOptions.addEventListener('click', (event) => {
          const optionBtn = event.target.closest('[data-variant-option-id]');
          if (!optionBtn) return;
          setSelectedVariant(optionBtn.dataset.variantOptionId);
          closeVariantDropdown();
        });
      }
      if (variantConfirm) {
        variantConfirm.addEventListener('click', () => addToCart(selectedVariant, variantConfirm));
      }
      if (variantClose) {
        variantClose.addEventListener('click', () => {
          closeVariantDropdown();
          if (variantModal?.open) variantModal.close();
        });
      }
      if (variantModal) {
        variantModal.addEventListener('click', (event) => {
          if (event.target === variantModal) {
            closeVariantDropdown();
            variantModal.close();
          }
        });
        variantModal.addEventListener('close', () => {
          closeVariantDropdown();
        });
      }
      root.addEventListener('click', (event) => {
        if (!variantPicker || !variantPicker.classList.contains('is-open')) return;
        if (!variantPicker.contains(event.target)) {
          closeVariantDropdown();
        }
      });

      setupProductCards();
      initProductSliders();
      initVideoCarousel();
      bindVideoModal();

      const handleResize = () => {
        clearProductTimers();
        initProductSliders();
      };

      window.addEventListener('resize', handleResize, { passive: true });
      root.addEventListener('shopify:section:unload', () => {
        clearProductTimers();
        window.removeEventListener('resize', handleResize);
      });
    }

    function initAll() {
      document.querySelectorAll('.sigallery').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
